import { useState } from 'react';
import MenuItem from '@material-ui/core/MenuItem';
import Menu from '@material-ui/core/Menu';
import { useUserContext } from '../context/UserContext';
import { useCartContext } from '../context/CartContext'; 
import { userActionTypes, cartActionTypes } from '../app/enums';
import { Fab }from '@material-ui/core';
import { Avatar } from '@material-ui/core';
import AccountCircle from '@material-ui/icons/AccountCircle';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles ({
    primaryText: {
      color: theme.palette.primary.contrastText,
      background: theme.palette.primary.main,
    },
    toolbarTitle: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-end',
      padding: theme.spacing(0, 1),
    },
  }),
);

export const ProfileMenu = () => {
  const { state, dispatch } = useUserContext()
  const user = state.self;
  const cart = useCartContext();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const classes = useStyles();
  const open = Boolean(anchorEl);

  const handleMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    dispatch({ type: userActionTypes.LOGOUT_USER })
    cart.dispatch({ type: cartActionTypes.RESET_CART })

    setAnchorEl(null);   
  };

  let button;
  if(user.id.trim() !== ''){
    button = 
      <Avatar 
        className={classes.primaryText} 
        onClick={handleMenu}
      >
        {user.firstName.charAt(0)}{user.lastName.charAt(0)}
      </Avatar>
  } else {
    button = 
      <Fab 
        aria-label="profile" 
        color="primary" 
        onClick={handleMenu}
      >
        <AccountCircle style={{ fontSize: 30 , color: 'inherit' }} />
      </Fab>
  }

  return (
    <div className={classes.toolbarTitle}>
      {button} 
      <Menu
        id="menu-appbar"
        anchorEl={anchorEl}
        getContentAnchorEl={null}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        keepMounted
        transformOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        open={open}
        onClose={handleClose}
      >
        <MenuItem onClick={() => handleLogout()}>Logout</MenuItem>
      </Menu>
    </div>
  );
};

export default ProfileMenu;
